const mounds = [
  {
    id: 1,
    image: "https://i.ibb.co/jZ3ZN9L8/IMG-9989.jpg",
    code: "Холм 1",
    price: "",
  },
  {
    id: 2,
    image: "https://i.ibb.co/1Y0JYLLg/photo-2026-02-09-17-31-18.jpg",
    code: "Холм 2",
    price: "",
  },
  {
    id: 3,
    image: "https://i.ibb.co/kbL4GM2/photo-2026-02-09-17-31-21.jpg",
    code: "Холм 3",
    price: "",
  },
  {
    id: 4,
    image: "https://i.ibb.co/mrcvVf07/photo-2026-02-23-15-07-58.jpg",
    code: "Холм 4",
    price: "",
  },
];

export default mounds;
